// zh.js
module.exports = {
  我要: '我要',
  办赛: '办赛',
  首页: '首页',
  赛事专区: '赛事专区',
  产品中心: '产品中心',
  机构: '机构',
  教练: '教练',
  运动员: '运动员',
  赛事: '赛事',
  参赛人次: '参赛人次',
  赛事一站式服务平台: '赛事一站式服务平台',
  创建专属赛事官网: '创建专属赛事官网',
  赛事数据永久保存: '赛事数据永久保存',
  智能报名规避错报: '智能报名规避错报',
  一键抽签编排: '一键抽签编排',
  '一键下载秩序册、对战表': '一键下载秩序册、对战表',
  智能检录呼叫号码: '智能检录呼叫号码',
  智能竞赛设备: '智能竞赛设备',
  成绩实时云同步: '成绩实时云同步',
  一键制作参赛证奖状: '一键制作参赛证奖状',
  '参数数据、技术分析': '参数数据、技术分析',
  竞赛物联网: '竞赛物联网',
  '为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通':
    '为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通',
  '裁判打分手柄/技术平板': '裁判打分手柄/技术平板',
  '运动员穿戴设备、竞赛硬件设备': '运动员穿戴设备、竞赛硬件设备',
  录像审议视频采集: '录像审议视频采集',
  检录处发送检录通知: '检录处发送检录通知',
  现场终端: '现场终端',
  记时记分比赛投屏: '记时记分比赛投屏',
  比赛进程: '比赛进程',
  '成绩、人气排行榜': '成绩、人气排行榜',
  技术统计数据分析: '技术统计数据分析',
  比赛直播: '比赛直播',
  比赛场次: '比赛场次',
  竞赛项目: '竞赛项目',
  近期赛事: '近期赛事',
  名称: '名称',
  地区: '地区',
  类型: '类型',
  报名流程: '报名流程',
  选择单位: '选择单位',
  录入领队及教练: '录入领队及教练',
  选手报名: '选手报名',
  参赛选手: '参赛选手',
  '报名完成/下载凭证': '报名完成/下载凭证',
  '您还没有单位，请先创建一个参赛单位': '您还没有单位，请先创建一个参赛单位',
  赛事主页: '赛事主页',
  参赛数据: '参赛数据',
  场次对战: '场次对战',
  奖牌榜: '奖牌榜',
  赛事公告: '赛事公告',
  组织机构: '组织机构',
  报名时间: '报名时间',
  比赛时间: '比赛时间',
  联系方式: '联系方式',
  扫码进入小程序: '扫码进入小程序',
  开赛时间: '开赛时间',
  赛事地址: '赛事地址',
  赛事级别: '赛事级别',
  赛事热度: '赛事热度',
  赛事附件: '赛事附件',
  服务范围: '服务范围',
  联系我们: '联系我们',
  新媒体: '新媒体',
  客服工作时间: '客服工作时间',
  '非工作时间我们不能及时回复您的信息，请在站内信留': '非工作时间我们不能及时回复您的信息，请在站内信留',
  下问题或留下您的联系方式我们将在第一时间联系到您: '下问题或留下您的联系方式我们将在第一时间联系到您',
  道吧小程序: '道吧小程序',
  道吧公众号: '道吧公众号',
  选择带队成员: '选择带队成员',
  参赛人员信息填写: '参赛人员信息填写',
  正在修改运动员的报名项目: '正在修改运动员的报名项目',
  继续报名新运动员: '继续报名新运动员',
  选手姓名: '选手姓名',
  主教练: '主教练',
  '* 主教练': '* 主教练',
  领队: '领队',
  裁判: '裁判',
  副教练: '副教练',
  经理: '经理',
  官员: '官员',
  队医: '队医',
  队长: '队长',
  点击添加: '点击添加',
  上传证件照: '上传证件照',
  身份证号: '身份证号',
  护照号: '护照号',
  必填: '必填',
  '检测通过，自动获取身份证信息': '检测通过，自动获取身份证信息',
  '点击检测，获取项目': '点击检测，获取项目',
  本平台购买保险无需上传保单: '本平台购买保险无需上传保单',
  '点击检测，获取符合自身年龄段的项目': '点击检测，获取符合自身年龄段的项目',
  '请录入运动员信息后，点击检测': '请录入运动员信息后，点击检测',
  没有检测到符合年龄的项目: '没有检测到符合年龄的项目',
  '注：提交之前请检查所报项目，以免错报或误报！': '注：提交之前请检查所报项目，以免错报或误报！',
  报名提交: '报名提交',
  带队成员: '带队成员',
  '报名须知：团体项目，请检查报名人数是否满足，若符合报名要求，即可进入到最后一步，下载凭证，若无法进入到下一步，请检查报名信息':
    '报名须知：团体项目，请检查报名人数是否满足，若符合报名要求，即可进入到最后一步，下载凭证，若无法进入到下一步，请检查报名信息',
  运动员参赛信息: '运动员参赛信息',
  报名总人数: '报名总人数',
  我已查看并同意: '我已查看并同意',
  保险条款: '保险条款',
  客户告知书: '客户告知书',
  报名完成下载凭证: '报名完成/下载凭证',
  恭喜报名成功: '恭喜报名成功',
  下载报名列表: '下载报名列表',
  官方打印版: '官方打印版',
  完整信息版: '完整信息版',
  下载保险凭证: '下载保险凭证',
  '以机构名义报名参赛，重新选择机构': '以机构名义报名参赛，重新选择机构',
  上一步: '上一步',
  下一步: '下一步',
  检查报名状态: '检查报名状态',
  '以个人身份报名参赛，进入选手报名': '以个人身份报名参赛，进入选手报名',
  道吧赛事平台能为组委会: '道吧赛事平台能为组委会',
  让天下没有难办的赛事: '让天下没有难办的赛事',
  节省: '节省',
  人工: '人工',
  提高: '提高',
  的工作效率: '的工作效率',
  规避: '规避',
  错报漏报: '错报漏报',
  组委会: '组委会',
  '提供全项目&全赛制，一站式办赛服务支撑': '提供全项目&全赛制，一站式办赛服务支撑',
  '以智能竞赛系统+竞赛设备双引擎，为国家体育总局、教育部、各省市体育协会、学校、俱乐部等办赛机构，':
    '以智能竞赛系统+竞赛设备双引擎，为国家体育总局、教育部、各省市体育协会、学校、俱乐部等办赛机构，',
  '提供从赛事运营、赛事执行、参赛数据统计&分析及赛事直播、后勤保障等线上+线下一站式服务支撑，':
    '提供从赛事运营、赛事执行、参赛数据统计&分析及赛事直播、后勤保障等线上+线下一站式服务支撑，',
  '服务已达34个省级行政区，90000+场次比赛': '服务已达34个省级行政区，90000+场次比赛',
  查看服务流程: '查看服务流程',
  主管部门: '主管部门',
  '主管部门、体育协会': '主管部门、体育协会',
  '可以通过平台查询、管理辖区内历届各机构、参赛队及运动员的':
    '可以通过平台查询、管理辖区内历届各机构、参赛队及运动员的',
  '参赛数据，统计排名，并根据需求提供各种统计分析结果，': '参赛数据，统计排名，并根据需求提供各种统计分析结果，',
  '便于主管部门了解当地体育单位的赛事状况，': '便于主管部门了解当地体育单位的赛事状况，',
  对并未决策提供科学的数据依据: '对并未决策提供科学的数据依据',
  查看详细介绍: '查看详细介绍',
  '运动队&运动员': '运动队&运动员',
  '随时掌握比赛进程；比赛信息互联互通': '随时掌握比赛进程；比赛信息互联互通',
  '检录提醒，及时提醒运动员在恰当时间去完成检录': '检录提醒，及时提醒运动员在恰当时间去完成检录',
  比赛过程中自动完成攻防双方技术统计: '比赛过程中自动完成攻防双方技术统计',
  '提供对战双方攻防数据统计分析，便于进行赛后总结，': '提供对战双方攻防数据统计分析，便于进行赛后总结，',
  '针对性调整训练方法，有效提高运动员成绩': '针对性调整训练方法，有效提高运动员成绩',
  '所有比赛战绩、胜率、积分状况，技术指标等海量数据，实时完整的永久保存':
    '所有比赛战绩、胜率、积分状况，技术指标等海量数据，实时完整的永久保存',
  成功案例: '成功案例',
  下载中心: '下载中心',
  战略合作单位: '战略合作单位',
  暂未上传数据: '暂未上传数据',
  序号: '序号',
  信息: '信息',
  操作: '操作',
  案例准备中: '案例准备中',
  下载: '下载',
  修改资料: '修改资料',
  个人报名运动员管理: '个人报名运动员管理',
  我的机构: '我的机构',
  '你还没有自己的机构，点击创建机构': '你还没有自己的机构，点击创建机构',
  成为机构用户: '成为机构用户',
  授权机构: '授权机构',
  添加授权账号: '添加授权账号',
  简称: '简称',
  '注：简称将用于对战的队伍信息展示': '注：简称将用于对战的队伍信息展示',
  授权管理: '授权管理',
  普通运动员: '普通运动员',
  团队管理: '团队管理',
  球队管理: '球队管理',
  用于比分大图展示: '用于比分大图展示',
  '注：用于比赛打分投屏（例图）': '注：用于比赛打分投屏（例图）',

  沟通需求: '沟通需求',
  '专人沟通办赛内容、需求': '专人沟通办赛内容、需求',
  发送赛事规程: '发送赛事规程',
  将赛事规程发送给道吧服务专员: '将赛事规程发送给道吧服务专员',
  组建赛事专属服务团队: '组建赛事专属服务团队',
  '团队包含：软件工程师、硬件工程师、赛事督导 赛事线上服务专员、赛事现场执行、VI设计':
    '团队包含：软件工程师、硬件工程师、赛事督导 赛事线上服务专员、赛事现场执行、VI设计',
  //服务流程
  赛事执行: '赛事执行',
  赛前: '赛前',
  比赛现场: '比赛现场',
  赛后: '赛后',
  创建赛事官网: '创建赛事官网',
  智能报名: '智能报名',
  生成参赛证: '生成参赛证',
  资格审查系统: '资格审查系统',
  称重系统: '称重系统',
  一键抽检编排: '一键抽检编排',
  '秩序册、对战表下载': '秩序册、对战表下载',
  智能检录: '智能检录',
  成绩实时云端同步: '成绩实时云端同步',
  技术统计分析: '技术统计分析',
  '赛事录屏/直播': '赛事录屏/直播',
  '奖牌榜/人气榜': '奖牌榜/人气榜',
  智能体能监测设备: '智能体能监测设备',
  成绩册下载: '成绩册下载',
  参赛视频下载: '参赛视频下载',
  打印获奖证书: '打印获奖证书',
  多维度参赛数据分析: '多维度参赛数据分析',
  保险团购: '保险团购',
  '奖杯 奖牌设计制作': '奖杯 奖牌设计制作',
  '保赛事整体VI设计 及制作险团购': '保赛事整体VI设计 及制作险团购',
  酒店预订: '酒店预订',
  赛场导航: '赛场导航',
  餐厅预订: '餐厅预订',
  智能叫车: '智能叫车',
  酒店自动入驻: '酒店自动入驻',
  自动退房: '自动退房',
  网上签到: '网上签到',
  外延服务: '外延服务',
  '团队包含：软件工程师、硬件工程师、赛事督导赛事线上服务专员、赛事现场执行、VI设计':
    '团队包含：软件工程师、硬件工程师、赛事督导赛事线上服务专员、赛事现场执行、VI设计',
  赛事财务统计: '赛事财务统计',
  活动专区: '活动专区',
  运动员榜: '运动员榜',
  机构榜: '机构榜',
  场馆: '场馆',
  报名已截止: '报名已截止',
  快捷登录: '快捷登录',
  微信登录: '微信登录',
  账户登录: '账户登录',
  请输入账号: '请输入账号',
  请输入密码: '请输入密码',
  登录: '登 录',
  账号注册: '账号注册',
  忘记密码: '忘记密码',
  邮箱注册: '邮箱注册',
  昵称: '昵称',
  请输入昵称: '请输入昵称',
  账号: '账号',
  邮箱或中国大陆手机号: '邮箱或中国大陆手机号',
  验证码: '验证码',
  请输入验证码: '请输入验证码',
  获取验证码: '获取验证码',
  密码: '密码',
  确认密码: '确认密码',
  请输入确认密码: '请输入确认密码',
  重置密码: '重置密码',
  手机或邮箱: '手机/邮箱',
  再次输入: '再次输入',
  请输入姓名: '请输入姓名',
  请输入身份证号: '请输入身份证号',
  请输入护照号: '请输入护照号',
  请选择出生日期: '请选择出生日期',
  赛事中心: '赛事中心',
  退出登录: '退出登录',
  状态: '状态',
  场地: '场地',
  进程: '进程',
  场次号: '场次号',
  项目: '项目',
  参赛信息: '参赛信息',
  结果: '结果',
  参赛人数: '参赛人数',
  机构类型: '机构类型',
  团体排名: '团体排名',
  项目排名: '项目排名',
  筛选: '筛选',
  搜索: '搜索',
  按项目筛选: '按项目筛选',
  按组别筛选: '按组别筛选',
  全部项目: '全部项目',
  全部: '全部',
  项目EXCEL奖牌榜: '项目EXCEL奖牌榜',
  Pdf成绩册: 'Pdf成绩册',
  Pdf项目名次表: 'Pdf项目名次表',
  队伍名称: '队伍名称',
  项目名称: '项目名称',
  团体总分: '团体总分',
  创建单位信息: '创建单位信息',
  单位名称: '单位名称',
  请输入单位名称: '请输入单位名称',
  单位简称: '单位简称',
  请输入单位简称: '请输入单位简称',
  联系人员: '联系人员',
  联系电话: '联系电话',
  单位类型: '单位类型',
  请选择单位类型: '请选择单位类型',
  所属地区: '所属地区',
  请选择地区: '请选择地区',
  详细地址: '详细地址',
  请输入详细地址: '请输入详细地址',
  提交数据: '提交数据',
  上传logo: '上传logo',
  俱乐部: '俱乐部',
  协会: '协会',
  学校: '学校',
  企业: '企业',
  事业单位: '事业单位',
  政府机关: '政府机关',
  编辑单位信息: '编辑单位信息',
  头像: '头像',
  姓名: '姓名',
  性别: '性别',
  民族: '民族',
  出生日期: '出生日期',
  证件号: '证件号',
  职位: '职位',
  关联项目: '关联项目',
  手机号: '手机号',
  队伍logo: '队伍logo'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js